module.exports = __webpack_public_path__ + "static/media/phonecall2.8c027cb5.svg";